import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
  Popover,
  PopoverHeader,
  PopoverBody,
} from 'reactstrap';
import { CloseButton } from 'dabbl-react-components';
import {RETAILER_NAME} from "../../../../retailerValues";

class HowDoesThisWorkPopUp extends Component {

  static propTypes = {
    // Required
    isOpen: PropTypes.bool.isRequired,
    onTogglePopup: PropTypes.func.isRequired,
  }

  render() {
    const {
      isOpen,
      onTogglePopup,
    } = this.props;

    return (
      <div>
        {/*<div*/}
        {/*  id="howDoesThisWork"*/}
        {/*  className="HowDoesThisWorkPopUp_trigger_text"*/}
        {/*>*/}
        {/*  <span onClick={onTogglePopup}>*/}
        {/*    How does this work?*/}
        {/*  </span>*/}
        {/*</div>*/}

        {/*<Popover*/}
        {/*  isOpen={isOpen}*/}
        {/*  target="howDoesThisWork"*/}
        {/*  placement="top"*/}
        {/*>*/}
        {/*  <PopoverHeader className="HowDoesThisWorkPopUp_title">*/}
        {/*    <div>How does this work?</div>*/}

        {/*    <div style={{display: 'inline-block'}}>*/}
        {/*      <CloseButton*/}
        {/*        className="HowDoesThisWorkPopUp_closeBtn"*/}
        {/*        onClick={onTogglePopup}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*  </PopoverHeader>*/}

        {/*  <PopoverBody className="HowDoesThisWorkPopUp_content">*/}
        {/*    <p>Add one coupon to your card at a time - $1, $3, $6, or $9.</p>*/}
        {/*    <p>*/}
        {/*      Once your coupon is added, redeem it at your local store at checkout.*/}
        {/*    </p>*/}
        {/*    <p>*/}
        {/*      Your account may only have one coupon at a time. Coupons must*/}
        {/*      be redeemed before additional coupons may be added.*/}
        {/*    </p>*/}
        {/*    <p>*/}
        {/*      It may take up to 48 hours for in-store redemptions to be*/}
        {/*      reflected here.*/}
        {/*    </p>*/}
        {/*  </PopoverBody>*/}
        {/*</Popover>*/}
      </div>
    );
  }
}

export default HowDoesThisWorkPopUp;



// WEBPACK FOOTER //
// ./src/pages/Account/components/HowDoesThisWorkPopUp/HowDoesThisWorkPopUp.js